import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AppLauncher/app-launcher';
import { DropdownItem } from '../Dropdown';
import { ApplicationLauncherContent } from './ApplicationLauncherContent';
import { ApplicationLauncherContext } from './ApplicationLauncher';
import StarIcon from '@patternfly/react-icons/dist/js/icons/star-icon';
export const ApplicationLauncherItemContext = React.createContext({
  isExternal: false,
  icon: null
});
export const ApplicationLauncherItem = _ref => {
  let _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      id = _ref.id,
      children = _ref.children,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      _ref$isExternal = _ref.isExternal,
      isExternal = _ref$isExternal === void 0 ? false : _ref$isExternal,
      href = _ref.href,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? null : _ref$tooltip,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === void 0 ? null : _ref$tooltipProps,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      _ref$isFavorite = _ref.isFavorite,
      isFavorite = _ref$isFavorite === void 0 ? null : _ref$isFavorite,
      _ref$ariaIsFavoriteLa = _ref.ariaIsFavoriteLabel,
      ariaIsFavoriteLabel = _ref$ariaIsFavoriteLa === void 0 ? 'starred' : _ref$ariaIsFavoriteLa,
      _ref$ariaIsNotFavorit = _ref.ariaIsNotFavoriteLabel,
      ariaIsNotFavoriteLabel = _ref$ariaIsNotFavorit === void 0 ? 'not starred' : _ref$ariaIsNotFavorit,
      customChild = _ref.customChild,
      _ref$enterTriggersArr = _ref.enterTriggersArrowDown,
      enterTriggersArrowDown = _ref$enterTriggersArr === void 0 ? false : _ref$enterTriggersArr,
      props = _objectWithoutProperties(_ref, ["className", "id", "children", "icon", "isExternal", "href", "tooltip", "tooltipProps", "component", "isFavorite", "ariaIsFavoriteLabel", "ariaIsNotFavoriteLabel", "customChild", "enterTriggersArrowDown"]);

  return React.createElement(ApplicationLauncherItemContext.Provider, {
    value: {
      isExternal,
      icon
    }
  }, React.createElement(ApplicationLauncherContext.Consumer, null, ({
    onFavorite
  }) => React.createElement(DropdownItem, _extends({
    id: id,
    component: component,
    href: href || null,
    className: css(isExternal && styles.modifiers.external, isFavorite !== null && styles.modifiers.link, className),
    listItemClassName: css(onFavorite && styles.appLauncherMenuWrapper, isFavorite && styles.modifiers.favorite),
    tooltip: tooltip,
    tooltipProps: tooltipProps
  }, enterTriggersArrowDown === true && {
    enterTriggersArrowDown
  }, customChild && {
    customChild
  }, isFavorite !== null && {
    additionalChild: React.createElement("button", {
      className: css(styles.appLauncherMenuItem, styles.modifiers.action),
      "aria-label": isFavorite ? ariaIsFavoriteLabel : ariaIsNotFavoriteLabel,
      onClick: () => {
        onFavorite(id, isFavorite);
      }
    }, React.createElement(StarIcon, null))
  }, props), children && React.createElement(ApplicationLauncherContent, null, children))));
};
ApplicationLauncherItem.propTypes = {
  icon: _pt.node,
  isExternal: _pt.bool,
  tooltip: _pt.node,
  tooltipProps: _pt.any,
  component: _pt.node,
  isFavorite: _pt.bool,
  ariaIsFavoriteLabel: _pt.string,
  ariaIsNotFavoriteLabel: _pt.string,
  id: _pt.string,
  customChild: _pt.node,
  enterTriggersArrowDown: _pt.bool
};